export class ValidationScopes {
// eslint-disable-next-line sonarjs/public-static-readonly
    static spara = "spara";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static skicka = "skicka";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static skapa = "skapa";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static utskrift = "utskrift";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static sok = "sök";
}
